import './sass/main.scss';
import './js/mobile-menu';
import './js/theme-changer';
import './js/scroll-up';
import './js/navigation-highlight';
import './js/books-gallery';
import './js/book-categories';
import './js/support.js';
import './js/booklist';
import './js/modal-registration';
import './js/firebase';
import './js/pop-up';
